import React from 'react';

export const ExtendIcon = props => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 3.63636V5.81818L9 2.90909L6 0V2.18182C2.685 2.18182 0 4.78545 0 8C0 9.14182 0.345 10.2036 0.93 11.0982L2.025 10.0364C1.6875 9.43273 1.5 8.73455 1.5 8C1.5 5.59273 3.5175 3.63636 6 3.63636ZM11.07 4.90182L9.975 5.96364C10.305 6.57455 10.5 7.26545 10.5 8C10.5 10.4073 8.4825 12.3636 6 12.3636V10.1818L3 13.0909L6 16V13.8182C9.315 13.8182 12 11.2145 12 8C12 6.85818 11.655 5.79636 11.07 4.90182Z"
      fill="#3EAC54"
    />
  </svg>
);
